import { FEProduct } from 'modules/products';
import { Solution } from '../solution-card';

/**
 * Возвращает URL для отправки товаров в корзину
 * @param {Solution} solution
 * @returns {string}
 */
const getBasketHref = (solution: Solution): string => {
  const productCountPair = solution.productIds
    .reduce((acc: string, productId: string) => {
      acc += `${productId}:${solution[productId].productCount},`;
      return acc;
    }, '')
    .slice(0, -1);

  return `basket/?products=%22${productCountPair}%22&landing=${solution.totalUrlLabel}`;
};

/**
 * Дополняет список решений доп. полями
 * @param productList
 * @param solution
 * @returns {Solution}
 */
export const enhanceSolution = (productList: FEProduct[], solution: Solution): Solution => {
  const totalInfo = productList.reduce(
    (acc, product) => {
      const { productCount } = solution[product.productId];

      return {
        totalCount: acc.totalCount + productCount,
        totalPrice: acc.totalPrice + Number(product.price) * productCount,
      };
    },
    { totalCount: 0, totalPrice: 0 }
  );

  return {
    ...solution,
    ...totalInfo,
    basketHref: getBasketHref(solution),
  };
};
